// src/utils/apiConfig.js
export const getRolePrefix = (role) => {
  if (!role) return "admin"; // fallback
  const normalized = role.toLowerCase();
  if (normalized === "teacher") return "teacher";
  if (normalized === "admin") return "institute";
  if (normalized === "accounts") return "institute";
  if (normalized === "parent") return "student";
  return "admin";
};
